import React, { useEffect, useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import LoadingBar from "react-top-loading-bar";
import { getRedeploymentRecipient, pushRedeploymentDetail } from "../../actions/memberAction";
import { toast } from "react-toastify";
import AlertError from "../common/alertError";
import AlertSuccess from "../common/alertSuccess";
import { getMember } from "../../actions/miscAction";
const RedeployAsset = ({ show, onHide, aucId, title }) => {
  const ref = useRef(null);

  const [loadingRecipients, setLoadingRecipients] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [recipientData, setRecipientData] = useState(null);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const member = getMember();

  const [inputData, setInputData] = useState({
    subject: "",
    message: "",
  });
  const [searchRecipient, setSearchRecipient] = useState("");

  useEffect(() => {
    if (show) {
      setLoadingRecipients(true);
      ref?.current?.continuousStart();
      getRedeploymentRecipient((res) => {
        setLoadingRecipients(false);
        ref?.current?.complete();
        if (res && res?.status == 200) {
          setRecipientData(res?.data?.recipients);
        }
      });
    }
  }, [show]);

  const onChange = (e) => {
    const value = { ...inputData };
    value[e.target.name] = e.target.value;
    setInputData(value);
  };

  const onSubmitHandler = () => {
    setLoadingSubmit(true);
    ref?.current?.continuousStart();
    const payload = {
      subject: inputData?.subject,
      body: inputData?.message,
      auction_ids: [aucId],
      recipient_uids: selectedRecipients,
    };
    pushRedeploymentDetail(payload, (res) => {
      setLoadingSubmit(false);
      ref?.current?.complete();
      if (res?.status === 200) {
        const value = { message: "", subject: "" };
        setInputData(value);
        setSelectedRecipients([]);
        toast(<AlertSuccess message={"Information Saved"} />);
        onHide();
      } else {
        toast(<AlertError message={res?.response?.message ? res?.response?.message : "Something went wrong"} />);
      }
    });
  };

  useEffect(() => {
    if (show) {
      const value = {
        subject: member?.company?.name ? `${member?.company?.name} Redeployment Assets` : "Redeployment Assets",
        message:
          "The following items are surplus inventory and available for redeployment. Please inquire if you have a use for any of these items.",
      };
      setInputData(value);
    } else {
      const value = { message: "", subject: "" };
      setInputData(value);
    }

    setSelectedRecipients([]);
  }, [show]);

  return (
    <>
      <LoadingBar height={5} color="var(--brand-color2)" ref={ref} />
      <Offcanvas
        className="offcanvas offcanvas-dashboard asset-redeploy-offcanvas offcanvas-end chat-screen"
        backdropClassName="modal-backdrop"
        placement="end"
        show={show}
        onHide={() => onHide()}
      >
        <Offcanvas.Header className="offcanvas-header border-bottom d-flex justify-content-between">
          <h5 id="offcanvasRightLabel">
            {aucId} - {title}
          </h5>

          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => onHide()}
          ></button>
        </Offcanvas.Header>
        <Offcanvas.Body class="offcanvas-body">
          <div class="offcanvas-view-listing">
            <>
              <div class="ovl-content-outer">
                <div class="ovl-content d-flex flex-wrap">
                  <div className="d-flex align-items-center">
                    <h6 className="redeploy-heading mt-3 mb-3">Internal Redeployment Tool</h6>
                    <line className="green-dash mx-3" />
                    <span className="redeploy-sub-heading">Maximize Asset Utilization Across Your Organization</span>
                  </div>
                  <div class="ovl-box w-100 " style={{ padding: "0px" }}>
                    <div className="redeploy-text redeploy-heading-text">
                      <p>
                        Salvex makes it easy to keep your team informed. With our streamlined tool, you can quickly
                        distribute new listings to all locations and inventory managers. Select the assets you want to
                        share, choose your recipients, and add a brief message regarding timelines or other crucial
                        details. This ensures everyone stays on the same page and saves money. Submit this form and
                        someone from the Salvex Team will get back to you.
                      </p>
                    </div>
                  </div>
                  <div class="__page-divider my-4"></div>
                  <div class="ovl-box w-100" style={{ padding: "0px" }}>
                    <h6>
                      Subject<sup style={{ color: "red" }}>*</sup>
                    </h6>

                    <input
                      type="text"
                      class="form-control"
                      id="subject"
                      name="subject"
                      onChange={onChange}
                      value={inputData?.subject}
                    />
                  </div>
                  <div class="ovl-box w-100 " style={{ padding: "0px" }}>
                    <h6>
                      Message<sup style={{ color: "red" }}>*</sup>
                    </h6>
                    <textarea
                      type="text"
                      class="form-control"
                      id="redeploymessage"
                      name="message"
                      style={{ height: "100px" }}
                      onChange={onChange}
                      value={inputData?.message}
                    />
                  </div>
                  <div class="__page-divider my-4"></div>
                  <div class="col-md-6 mb-3">
                    <input
                      type="text"
                      class="form-control"
                      id="subject"
                      name="subject"
                      placeholder="Search"
                      onChange={(e) => setSearchRecipient(e.target.value)}
                      value={searchRecipient}
                    />
                  </div>
                  <div class="table-responsive  my-sold-listings-table px-0 mx-0 pt-0 w-100">
                    <table class="table custom-accordion-table mb-0">
                      <thead>
                        <tr>
                          {" "}
                          <th style={{ width: "5%" }}>
                            {!loadingRecipients && !searchRecipient && (
                              <div className="form-check redeploy-form-check d-flex">
                                <input
                                  className="form-check-input redeploy-form-check-input"
                                  type="checkbox"
                                  name="recipients1"
                                  id="recipients1"
                                  onClick={(e) => {
                                    if (recipientData?.length === selectedRecipients?.length) {
                                      setSelectedRecipients([]);
                                    } else {
                                      const value = [...recipientData?.map((to, i) => to?.uid)];
                                      setSelectedRecipients(value);
                                    }
                                  }}
                                  checked={recipientData?.length === selectedRecipients?.length}
                                />
                                <label
                                  class="form-check-label redeploy-form-check-label"
                                  htmlFor={"recipients1"}
                                ></label>
                              </div>
                            )}
                          </th>
                          <th style={{ width: "30%" }}>Name</th>
                          <th style={{ width: "20%" }}>Title</th>
                          <th style={{ width: "20%" }}>Phone</th>
                          <th style={{ width: "25%" }}>Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingRecipients
                          ? [1, 2, 3, 4, 3, 6].map((t, i) => {
                              return (
                                <tr>
                                  <td className="vertical-align-top">
                                    <Skeleton />
                                  </td>
                                  <td>
                                    <Skeleton />
                                  </td>
                                  <td>
                                    <Skeleton />
                                  </td>
                                  <td>
                                    {" "}
                                    <Skeleton />
                                  </td>
                                  <td>
                                    {" "}
                                    <Skeleton />
                                  </td>
                                </tr>
                              );
                            })
                          : [
                              ...(searchRecipient
                                ? recipientData?.filter(
                                    (it) =>
                                      it?.name?.toLowerCase()?.includes(searchRecipient?.toLowerCase()) ||
                                      it?.email?.toLowerCase()?.includes(searchRecipient?.toLowerCase()),
                                  )
                                : recipientData || []),
                            ]?.map((t, i) => {
                              return (
                                <tr>
                                  <td className="vertical-align-top">
                                    <div className="form-check redeploy-form-check d-flex">
                                      <input
                                        className="form-check-input redeploy-form-check-input"
                                        type="checkbox"
                                        name={t?.uid}
                                        id={t?.uid}
                                        onChange={(e) => {
                                          if (selectedRecipients?.includes(t?.uid)) {
                                            const value = selectedRecipients?.filter((hd) => hd !== t?.uid);
                                            setSelectedRecipients(value);
                                          } else {
                                            const value = [...selectedRecipients];
                                            value.push(t?.uid);
                                            setSelectedRecipients(value);
                                          }
                                        }}
                                        checked={selectedRecipients?.includes(t?.uid)}
                                      />
                                      <label
                                        class="form-check-label redeploy-form-check-label"
                                        htmlFor={t?.uid}
                                      ></label>
                                    </div>
                                  </td>
                                  <td className="text-wrap">{t?.name}</td>
                                  <td className="text-wrap">{t?.job_title}</td>
                                  <td>
                                    {" "}
                                    <a className="dynamic-txt brand-link" href={`phone:${t?.phone}`}>
                                      {t?.phone}
                                    </a>
                                  </td>
                                  <td className="text-wrap">
                                    {" "}
                                    <a className="dynamic-txt brand-link" href={`mailto:${t?.email}`}>
                                      {t?.email}
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          </div>
          <div className="col-md-12 d-flex justify-content-end align-items-center">
            <a
              href="javascript:void(0)"
              class={`btn btn-brand-color2 text-uppercase btn-asset-redeploy ${
                loadingSubmit ||
                inputData?.message?.length === 0 ||
                inputData?.subject?.length === 0 ||
                selectedRecipients?.length === 0
                  ? "btn-disabled"
                  : ""
              } `}
              onClick={onSubmitHandler}
            >
              Submit
            </a>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default RedeployAsset;
